import { render, staticRenderFns } from "./ListagemPerfilMenuComponent.vue?vue&type=template&id=6eb5f4a8"
import script from "./ListagemPerfilMenuComponent.vue?vue&type=script&lang=js"
export * from "./ListagemPerfilMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports